<div class="w-full min-h-screen bg-[#F8F9FA] flex flex-col font-sans">
  
  <div *ngIf="isLoading" class="flex-grow flex justify-center items-center">
    <div class="w-4 h-4 rounded-full animate-pulse bg-[#1D4586] mr-1"></div>
    <div class="w-4 h-4 rounded-full animate-pulse bg-[#1D4586] mr-1"></div>
    <div class="w-4 h-4 rounded-full animate-pulse bg-[#1D4586]"></div>
  </div>

  <ng-container *ngIf="!isLoading && result">
    <!-- Top Header Area -->
    <div class="w-full bg-white px-8 py-5 border-b border-gray-200 shadow-sm flex flex-col">
      <div class="flex items-center">
        <img src="../../../assets/icons/copilot-bot.png" class="w-10 h-10 mr-4" alt="Bot" />
        <div>
          <div class="flex items-center space-x-3">
            <h2 class="text-xl font-bold text-[#1D4586]">{{ result.title }}</h2>
            <span class="px-3 py-0.5 rounded-full text-[11px] font-semibold" [ngClass]="getBadgeClass()">
              {{ getBadgeText() }}
            </span>
          </div>
          <p class="text-sm text-gray-500 mt-0.5">
            Summary of your attempt 
            <span *ngIf="result.attempt_no">&middot; attempt {{ result.attempt_no }} of {{ result.max_attempts }}</span>
          </p>
        </div>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="w-full max-w-5xl mx-auto px-4 py-8">
      
      <!-- Score Banner -->
      <div class="w-full bg-[#1D4586] rounded-xl p-8 flex items-center text-white shadow-md mb-8">
        <div class="text-6xl font-bold mr-6">{{ result.score_percent }}%</div>
        <div class="flex flex-col border-l border-white/30 pl-6">
          <span class="text-xl font-bold tracking-wide">{{ result.marks_scored }} marks out of {{ result.total_marks }}</span>
          <span *ngIf="result.status === 'not_cleared' && result.can_retake" class="text-sm mt-1 text-white/90">
            You can retake this assessment
          </span>
        </div>
      </div>

      <!-- Breakdown Table -->
      <div class="w-full bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden mb-6">
        <table class="w-full text-sm text-left">
          <thead class="bg-gray-50 text-gray-500 font-semibold text-xs uppercase border-b border-gray-200">
            <tr>
              <th scope="col" class="px-6 py-4">Question Type</th>
              <th scope="col" class="px-6 py-4 text-center">Questions</th>
              <th scope="col" class="px-6 py-4 text-center">Marks Scored</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr *ngFor="let row of result.breakdown" class="text-gray-800">
              <td class="px-6 py-4 font-medium">{{ row.label }}</td>
              <td class="px-6 py-4 text-center">{{ row.questions }}</td>
              <td class="px-6 py-4 text-center">{{ row.marks_scored }}</td>
            </tr>
            <tr class="font-bold text-gray-900 bg-gray-50/50">
              <td class="px-6 py-4">Total</td>
              <td class="px-6 py-4 text-center">{{ result.totals.questions }}</td>
              <td class="px-6 py-4 text-center">{{ result.totals.marks_scored }} / {{ result.totals.max_marks }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="text-[11px] text-gray-500 mb-8 italic px-2">
        A descriptive answer is evaluated by AI and awarded partial or full marks based on accuracy.
      </p>

      <!-- Action Buttons -->
      <div class="flex items-center space-x-4">
        <button *ngIf="result.status === 'not_cleared' && result.can_retake" 
                (click)="startRetake()"
                class="bg-[#1D4586] text-white px-6 py-2.5 rounded font-semibold text-sm hover:bg-[#16366b] transition-colors">
          Start retake
        </button>
        
        <button (click)="goBackToAssessments()"
                [ngClass]="result.status === 'not_cleared' && result.can_retake ? 'bg-white text-[#1D4586] border border-[#1D4586] hover:bg-gray-50' : 'bg-[#1D4586] text-white hover:bg-[#16366b]'"
                class="px-6 py-2.5 rounded font-semibold text-sm transition-colors">
          Back to assessments
        </button>
      </div>

    </div>
  </ng-container>
</div>